// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3U_Qj","rootSuccess":"CompleteLink_rootSuccess__1Eupc","rootFailure":"CompleteLink_rootFailure__wLLgw","isDisabled":"CompleteLink_isDisabled__s5uFa"};